export default "__VITE_ASSET__70ce99b1__"